var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"content_podat"},[(_vm.loading)?_c('div',{attrs:{"align":"center"}},[_c('div',{staticClass:"spin"},[_c('Spinner')],1)]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }